import { createFileRoute } from "@tanstack/react-router"

import { GoodsReceiptCommentsTab } from "@/screens/WarehouseReceiving/components"

export const Route = createFileRoute("/app/warehouse-receiving/soft-received/$goodsReceiptId/_layout/comments")({
  component: GoodsReceiptCommentsTab,
})
